export const UNSTRICT_WS = 'UNSTRICT_WS';
export const UNSTRICT_WS_SUCCESS = 'UNSTRICT_WS_SUCCESS';
export const UNSTRICT_WS_ERROR = 'UNSTRICT_WS_ERROR';
